'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const react = require('@emotion/react');
const styleEncapsulation = require('@zapier/style-encapsulation');
const components_forms_Typeahead_Typeahead = require('../../forms/Typeahead/Typeahead.cjs.js');
const components_forms_FloatingMenu_FloatingMenu = require('../../forms/FloatingMenu/FloatingMenu.cjs.js');
const components_patterns_ServiceTypeahead_useAppSearchData_useAppSearchData = require('./useAppSearchData/useAppSearchData.cjs.js');
const components_patterns_ServiceIcon_ServiceIcon = require('../ServiceIcon/ServiceIcon.cjs.js');

const Styles = styleEncapsulation.labelStyles("ServiceTypeahead", {
  serviceIcon: react.css`
    &[data-disabled] {
      opacity: 0.6;
    }
  `
});
const emptyItem = {
  disabled: true,
  name: "No search results found."
};
const dedupeAndTrimWhitespace = (query) => query.replace(/(\s+)/g, " ").trim();
const ServiceTypeahead = ({ apiHostname, "aria-label": ariaLabel, disabledText, id, initialSelectedItem, inputId, isDisabled, labelId, menuAriaLabel, onChange, placeholder, setClearSelection, size, slugFilter, excludeUpcoming = true, includeIsAppAdmin = true, includeIsAppCollaborator = true, onResultsUpdate = () => {
}, renderFloatingMenu = (props) => react.jsx(components_forms_FloatingMenu_FloatingMenu.FloatingMenu, Object.assign({}, props)), resultsLimit = 4 }) => {
  const getIconUrlForItem = (item) => item.images.url_32x32;
  const getLabelForItem = (item) => item.name;
  const renderIcon = (item) => {
    if (!item || !item.images) {
      return null;
    }
    return react.jsx(
      "span",
      { css: Styles.serviceIcon, "data-disabled": isDisabled ? "" : void 0, "data-zds": true },
      react.jsx(components_patterns_ServiceIcon_ServiceIcon.ServiceIcon, { "aria-hidden": true, serviceName: getLabelForItem(item), size: "small", src: getIconUrlForItem(item) })
    );
  };
  const { apps, loading, onSearch, searchQuery } = components_patterns_ServiceTypeahead_useAppSearchData_useAppSearchData.useAppSearchData({
    limit: resultsLimit,
    searchDebounceDelay: 300,
    excludeUpcoming,
    includeIsAppAdmin,
    includeIsAppCollaborator,
    apiHostname: apiHostname || "",
    onResultsUpdate
  });
  const filteredApps = !slugFilter ? apps : apps.filter((app) => app.slug !== slugFilter);
  const hasZeroResults = loading === false && searchQuery.length > 0 && filteredApps.length === 0;
  const displayedApps = hasZeroResults ? [emptyItem] : filteredApps;
  return react.jsx(components_forms_Typeahead_Typeahead.Typeahead, {
    "aria-label": ariaLabel,
    autoComplete: "off",
    disabledText,
    getLabelForItem,
    id,
    initialSelectedItem,
    inputId,
    isBusy: loading,
    isDisabled,
    // We are intentionally passing an empty `items` while loading previous
    // search results while searching. This prevents the user from clicking or
    // tapping on a result right after results suddenly change, which is a very
    // frustraing UX.
    //
    // Also passing empty `items` when the `searchQuery` is blank. This is
    // because `AppSearchBackend` returns a default set of apps when a
    // blank search query is specified. When the user type an initial
    // character into the `Typeahead`, these default apps render for a
    // split second, creating the impression of poor search results until
    // the GraphQL query returns.
    items: loading || searchQuery === "" ? [] : displayedApps,
    labelId,
    menuAriaLabel,
    onChange,
    onInputValueChange: (query) => onSearch(dedupeAndTrimWhitespace(query)),
    placeholder,
    renderFloatingMenu: (menuProps) => renderFloatingMenu(Object.assign(Object.assign({}, menuProps), { visibleItems: resultsLimit })),
    renderIcon,
    setClearSelection,
    showEmptyList: true,
    size
  });
};

exports.ServiceTypeahead = ServiceTypeahead;
//# sourceMappingURL=ServiceTypeahead.cjs.js.map
